<app-card padding="px-3 py-3">
  <div class="flex items-center justify-between gap-3">
    <img
      [src]="photoURL()"
      [alt]="displayName()"
      class="w-12 h-12 rounded-full border-2 border-secondary object-cover shrink-0"
    />
    <div class="flex flex-col flex-1 min-w-0">
      <span class="text-lg truncate">{{ displayName() }}</span>
      <span class="text-sm text-text-secondary truncate">{{ email() }}</span>
    </div>
    <div class="icon-wrapper">
      <ng-icon
        name="heroArrowRightStartOnRectangle"
        size="2rem"
        class="shrink-0 cursor-pointer"
        (click)="logout.emit()"
      ></ng-icon>
    </div>
  </div>
</app-card>
